import { RoleRoute, RouteFunctionParams } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { AdministrationDashboard } from '@/routes/admin/AdministrationDashboard'
import { getAzureUserInformation } from '@/auth/azure/azureManager'
import { LoaderFunction } from 'react-router-typesafe'

export const administrationDashboardRouteLoader = (async ({ request, params }: RouteFunctionParams) => {
  const userInfo = await getAzureUserInformation()
  return { userInfo }
}) satisfies LoaderFunction

export const AdministrationDashboardRoute: RoleRoute = {
  element: <AdministrationDashboard />,
  text: 'Dashboard',
  icon: 'preferences',
  index: true,
  mainMenuRoute: false,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
  loader: administrationDashboardRouteLoader,
}
